import axios from "@/http/axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch( params ) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          reasons (
            type: ${ params.type || 0 },
            ` + (params.id === undefined ? '' : `id: ${params.id}`) + `,
            ` + (params.deleted === undefined ? '' : `deleted: ${params.deleted}`) + `,
          ) {
            id,
            default,
            description,
            use_observation,
            require_observation,
            reason_options {
              id,
              number,
              is_required,
              description,
              reason_option_kind {
                id,
                description,
                min_items,
                max_items,
                tag
              },
              reason_option_kind_id,
              reason_option_items {
                id,
                description,
                reason_option_id
              }
            }
          }
        }
      `
    })
  },
  get(id, type = 0) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          reasons (
            id: ${id}
            type: ${type},
          ), {
            id,
            default
            description,
            use_observation,
            require_observation,
            reason_options {
              id,
              number,
              is_required,
              description,
              reason_option_kind_id,

              reason_option_kind {
                id,
                description,
                min_items,
                max_items,
                tag
              },
              
              reason_option_items {
                id,
                description
              }
            }
          }
        }
      `
    })
  },
  create(args) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          createReason (
            ${JSON.stringify(args).replaceAll(/"([a-zA-Z-_]+)":/g, "$1:").replace(/^\{/, '').replace(/\}$/, '').replace(/,null\]/, ']').replace(/,null,/, ',').replace(/\[null,/, '[')}
          ) {
            id
          }
        }
      `
    })
  },
  update(args) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          updateReason (
            ${JSON.stringify(args).replaceAll(/"([a-zA-Z-_]+)":/g, "$1:").replace(/^\{/, '').replace(/\}$/, '').replace(/,null\]/, ']').replace(/,null,/, ',').replace(/\[null,/, '[')}
          ) {
            id
          }
        }
      `
    })
  },
  remove(id) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        mutation {
          deleteReason (
            id: ${id}
          )
        }
      `
    })
  },
}
